import { BonusClassification, BonusSettlementSupplierStatus } from '@synergy/models';
import { BonusClassificationFilter, BooleanFilter, FilterModal, SearchFilter, StatusFilter } from '@synergy/components';

export const BonusSettlementSupplierOverviewFilter = () => {
    return (
        <>
            <FilterModal>
                <StatusFilter
                    documentStatus={[
                        BonusSettlementSupplierStatus.Open,
                        BonusSettlementSupplierStatus.PartiallySent,
                        BonusSettlementSupplierStatus.Sent,
                        BonusSettlementSupplierStatus.AutomaticallySent,
                        BonusSettlementSupplierStatus.Completed,
                        BonusSettlementSupplierStatus.Reclaimed,
                    ]}
                />
                <BonusClassificationFilter
                    bonusClassifications={[
                        BonusClassification.Bonus,
                        BonusClassification.BonusPlus,
                        BonusClassification.Contract,
                    ]}
                />
                <BooleanFilter filterName="hasActualBonus" labelTranslationId="app.select.option.bonus" />
            </FilterModal>
            <SearchFilter />
        </>
    );
};
